module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [(_vm.loading) ? _c('loading') : _vm._e(), (!_vm.loading && (_vm.submissions.length || !_vm.isExcerpt)) ? _c('div', {
    staticClass: "group-submissions-container",
    class: {
      excerpt: _vm.isExcerpt, full: !_vm.isExcerpt
    }
  }, [_c('h1', {
    staticClass: "banner"
  }, [(_vm.isInspecting) ? _c('span', [_vm._v("Dit hebben de leerlingen ingeleverd")]) : _c('span', [_vm._v("Dit hebben je klasgenoten gemaakt")])]), (_vm.submissions.length > 0) ? _c('div', [(_vm.isExcerpt) ? _c('div', [(_vm.type(_vm.submissions[0]) === 'Upload') ? _c('upload-presenter', {
    attrs: {
      "submissions": _vm.submissions,
      "mini": true
    }
  }) : _vm._l((_vm.submissions), function(submission) {
    return _c('question-presenter', {
      key: submission.id,
      attrs: {
        "submissions": [submission]
      }
    })
  }), (_vm.submissions.length >= 3) ? _c('router-link', {
    staticClass: "show-more-submissions button-timid button-forward",
    attrs: {
      "to": {
        name: 'assignment.group'
      }
    }
  }, [_vm._v("Meer")]) : _vm._e()], 2) : _c('div', _vm._l((_vm.users), function(user) {
    return _c('div', [_c('h4', [(_vm.isInspecting) ? _c('router-link', {
      staticClass: "show-student",
      attrs: {
        "to": {
          name: 'students.assignment.overview',
          params: {
            studentId: user.id
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(user.firstname) + " " + _vm._s(user.middlename) + " " + _vm._s(user.lastname) + " "), _c('br'), (user.hasFeedback) ? _c('span', {
      staticClass: "icon icon--inline icon--feedback-dark",
      attrs: {
        "title": "Heeft feedback gekregen"
      }
    }) : _vm._e(), (user.isRetaking) ? _c('span', {
      staticClass: "icon icon--inline icon--retake-dark",
      attrs: {
        "title": "Opdracht opnieuw inleveren"
      }
    }) : _vm._e(), (user.diligence) ? _c('span', {
      staticClass: "diligence__icon diligence__icon--bg-replace diligence__icon--mini active",
      class: 'diligence__icon--' + user.diligence.tag,
      attrs: {
        "title": user.diligence.tag
      }
    }) : _vm._e()]) : _c('span', [_vm._v(_vm._s(user.firstname) + " " + _vm._s(user.middlename) + " " + _vm._s(user.lastname))])], 1), (_vm.type(user.submissions[0]) === 'Upload') ? _c('upload-presenter', {
      attrs: {
        "submissions": user.submissions,
        "mini": true
      }
    }) : _vm._l((user.submissions), function(submission) {
      return _c('question-presenter', {
        key: submission.id,
        attrs: {
          "submissions": [submission]
        }
      })
    })], 2)
  }))]) : _c('p', [_vm._v("Er zijn nog geen ingeleverde opdrachten")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-426eb7ca","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/presenters/GroupSubmissions.vue
// module id = Uht+
// module chunks = 1